import React from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import DateInput from 'schedule/common/modules/date/DateInput'
import DropDownInput from '../common/DropDownInput'
import CommonRepository from '../infra/CommonRepository'
import Utils from '../infra/Utils'
import Styles from '../common/Styles'

const DateFilter = ({ style, from, to, onRangeStartChanged, onRangeEndChanged }) => {
  return (
    <div style={{ ...styles.dateFilterContainer, ...style }}>
      <DateInput
        style={{ marginRight: 6 }}
        hintText='From'
        value={from}
        onChange={(n, date) => onRangeStartChanged(date)} />
      <DateInput
        hintText='To'
        value={to}
        onChange={(n, date) => onRangeEndChanged(date)} />
    </div>
  )
}

DateFilter.propTypes = {
  style: PropTypes.object.isRequired,
  from: PropTypes.object,
  to: PropTypes.object,
  onRangeStartChanged: PropTypes.func.isRequired,
  onRangeEndChanged: PropTypes.func.isRequired
}

const NumberFilter = ({ style, value, billingEntity, onNumberChanged }) => {
  return (
    <input
      style={{ ...Styles.dropDownBox, ...style }}
      placeholder={`${Utils.capitalize(billingEntity)} Number`}
      value={value ? value : ''}
      onChange={event => onNumberChanged(event.target.value)} />
  )
}

NumberFilter.propTypes = {
  style: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
  billingEntity: PropTypes.string.isRequired,
  onNumberChanged: PropTypes.func.isRequired
}

export default class BillingFilters extends React.Component {

  static propTypes = {
    style: PropTypes.object.isRequired,
    billingEntity: PropTypes.string.isRequired,
    selectedTab: PropTypes.string,
    teamId: PropTypes.string.isRequired,
    onFilterChanged: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      customers: [ { id: 'all', name: 'All Customers' } ],
      customerId: 'all',
      status: 'all',
      from: null,
      to: null,
      number: 0
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedTab === 'draft') {
      this.setState({ status: 'draft' })
    }
    else
    if (nextProps.selectedTab === 'unpaid') {
      this.setState({ status: 'unpaid' })
    }
  }

  componentDidMount() {
    CommonRepository.addCustomersListener(this.props.teamId, this.onCustomersValue)
  }

  componentWillUnmount() {
    CommonRepository.removeCustomersListener(this.props.teamId, this.onCustomersValue)
  }

  onCustomersValue = snapshot => {
    const value = snapshot && snapshot.val()
    const list = value && _.map(value) || []
    if (list.length) {
      this.setState({
        customers: [ { id: 'all', name: 'All Customers' } ].concat(list)
      })
    }
  }

  handleCustomerDropDownValueChanged = customerId => {
    const newState = Object.assign({}, this.state, { customerId })
    this.setState(newState)
    this.props.onFilterChanged(newState)
  }

  handleStatusDropDownValueChanged = status => {
    const newState = Object.assign({}, this.state, { status })
    this.setState(newState)
    this.props.onFilterChanged(newState)
  }

  handleRangeStartChanged = from => {
    const newState = Object.assign({}, this.state, { from })
    this.setState(newState)
    this.props.onFilterChanged(newState)
  }

  handleRangeEndChanged = to => {
    const newState = Object.assign({}, this.state, { to })
    this.setState(newState)
    this.props.onFilterChanged(newState)
  }

  handleNumberChanged = input => {
    let number = parseInt(input)
    if (isNaN(number)) {
      number = 0
    }
    const newState = Object.assign({}, this.state, { number })
    this.setState(newState)
    this.props.onFilterChanged(newState)
  }

  render() {
    return (
      <div style={{ ...styles.container, ...this.props.style }}>
        <DropDownInput
          value={this.state.customerId}
          list={this.state.customers}
          onValueChanged={this.handleCustomerDropDownValueChanged} />
        <DropDownInput
          style={{ marginLeft: 32 }}
          value={this.state.status}
          // Do not allow to change status filter selector when a tab is selected.
          disabled={this.props.selectedTab !== 'all'}
          list={this.props.billingEntity === 'invoice' ? INVOICE_STATUSES : ESTIMATE_STATUSES}
          onValueChanged={this.handleStatusDropDownValueChanged} />
        <DateFilter
          style={{ marginLeft: 32 }}
          from={this.state.from}
          to={this.state.to}
          onRangeStartChanged={this.handleRangeStartChanged}
          onRangeEndChanged={this.handleRangeEndChanged} />
        <NumberFilter
          style={{ marginLeft: 32 }}
          value={this.state.number}
          billingEntity={this.props.billingEntity}
          onNumberChanged={this.handleNumberChanged} />
      </div>
    )
  }

}

const INVOICE_STATUSES = [
  { id: 'all', name: 'All Statuses' },
  { id: 'draft', name: 'Draft' },
  { id: 'sent', name: 'Sent' },
  { id: 'paid', name: 'Paid' },
  { id: 'partial', name: 'Partial' },
  { id: 'unpaid', name: 'Unpaid' }
]

const ESTIMATE_STATUSES = [
  { id: 'all', name: 'All Statuses' },
  { id: 'draft', name: 'Draft' },
  { id: 'sent', name: 'Sent' }
]

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  dateFilterContainer: {
    display: 'flex',
    flexDirection: 'row'
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/BillingFilters.js